import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckbox } from '@angular/material/checkbox';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';

import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';

import { LayoutModule } from '../shared/components/layout/layout.module';
import { DirectivesModule } from '../shared/directives/directives.module';

import { LoaderComponent } from './components/loader/loader.component';
import { CountdownComponent } from './components/countdown/countdown.component';
import { SubscriptionInfoComponent } from './components/subscription/subscription-info/subscription-info.component';
import { StatusLabelComponent } from '../shared/components/status-label/status-label.component';
import { FilterTagsLabelComponent } from '../shared/components/filter-tags-label/filter-tags-label.component';
import { EmployeeTitlesComponent } from '../shared/components/employee-titles/employee-titles.component';
import { EmployeeAvatarComponent } from '../shared/components/employee-avatar/employee-avatar.component';
import { GoogleSigninButtonComponent } from '../shared/components/google-signin-button/google-signin-button.component';
import { PlansListComponent } from '../shared/components/subscription/plans-list/plans-list.component';

import { SearchPipe } from './pipes/search.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { DurationSincePipe } from './pipes/duration-since.pipe';
import { EmployeeFullNamePipe } from './pipes/employee-full-name.pipe';

import {
  SubscriptionCountdownComponent
} from './components/subscription/subscription-countdown/subscription-countdown.component';
import { CompanyCardComponent } from './components/company/company-card/company-card.component';
import { CompanyCardSubscriptionComponent } from './components/company/company-card-subscription/company-card-subscription.component';
import { SubscriptionStatsComponent } from './components/subscription/subscription-stats/subscription-stats.component';
import { SubscriptionHistoryComponent } from './components/subscription/subscription-history/subscription-history.component';
import { ToastComponent } from './components/toast/toast.component';
import { AddButtonComponent } from './components/add-button/add-button.component';
import { NotificationComponent } from './components/modals/notification/notification.component';
import { ScimConfigModalComponent } from './components/modals/scim-config-modal/scim-config-modal.component';

@NgModule({
  declarations: [
    LoaderComponent,
    CountdownComponent,
    SearchPipe,
    SanitizeHtmlPipe,
    StripHtmlPipe,
    DurationSincePipe,
    EmployeeFullNamePipe,
    StatusLabelComponent,
    ToastComponent,
    FilterTagsLabelComponent,
    EmployeeTitlesComponent,
    EmployeeAvatarComponent,
    GoogleSigninButtonComponent,
    PlansListComponent,
    SubscriptionInfoComponent,
    SubscriptionCountdownComponent,
    CompanyCardComponent,
    CompanyCardSubscriptionComponent,
    SubscriptionStatsComponent,
    SubscriptionHistoryComponent,
    AddButtonComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatTabsModule,
    MatMenuModule,
    MatSlideToggleModule,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    MatCheckbox,

    NgxTrimDirectiveModule,
    TranslateModule,
    ToastrModule,
    GoogleSigninButtonModule,

    LayoutModule,
    DirectivesModule,
  ],
  providers: [
    EmployeeFullNamePipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LayoutModule,
    DirectivesModule,

    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatTabsModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatCheckbox,

    NgxTrimDirectiveModule,
    TranslateModule,
    ToastrModule,
    GoogleSigninButtonModule,

    LoaderComponent,
    CountdownComponent,
    StatusLabelComponent,
    ToastComponent,
    EmployeeTitlesComponent,
    EmployeeAvatarComponent,
    FilterTagsLabelComponent,
    GoogleSigninButtonComponent,
    PlansListComponent,
    SubscriptionInfoComponent,
    SubscriptionCountdownComponent,
    SearchPipe,
    SanitizeHtmlPipe,
    StripHtmlPipe,
    DurationSincePipe,
    EmployeeFullNamePipe,
    CompanyCardComponent,
    SubscriptionHistoryComponent,
    AddButtonComponent,
    NotificationComponent
  ]
})
export class SharedModule {}
